import React, { useContext } from "react";
import "../Sidebar/sidebar.css";
import FormContext from "../../context/FormContext";

const SidebarItems = () => {
  const context = useContext(FormContext);
  const { FormInputOptions, handleSidebar } = context;

  return (
    <div>
      <ul className="text-center px-2  mx-auto">
        {FormInputOptions.map((item, i) => {
          return (
            <li
              style={{ cursor: "pointer" }}
              key={i}
              className="my-2 px-1 sidebar-item py-1 border border-white rounded"
              id={item.LiId}
              onClick={(e) => handleSidebar(item.LiId, item.Component)}
            >
              {item.Icon}
              {item.Name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SidebarItems;
